import React from 'react'
import styled, { css } from 'styled-components/macro'
import { darken, lighten } from 'polished'
import { button as textstyle } from 'styles/mixins/textstyles'
import { Link } from 'react-router-dom'

function palette(shade, defaultGroup='primary') {
  return props => {
    const group = props.palette || defaultGroup
    const color = props.theme.colors[`${group}${shade}`]
    if (color) {
      return color
    } else {
      const base = props.theme.colors[`${group}Base`] || props.theme.colors[group] || group
      switch(shade) {
        case 'Light': return lighten(0.585, base)
        case 'Lighter': return lighten(0.385, base)
        case 'Base': return base
        case 'Dark': return darken(0.11, base)
        case 'Darker': return darken(0.256, base)
        default: return base
      }
    }
  }
}

function primary() {
  return css`
    ${textstyle('white')}
    display: block;
    width: 100%;
    transition: all 150ms ease;
    padding: 1.5rem;
    background: ${palette('Base')};
    border: 1px solid ${palette('Base')};
    border-radius: 5px;
    text-align: center;
    cursor: pointer;

    &:hover {
      background: ${palette('Darker')};
      border-color: ${palette('Darker')};
      color: white;
    }

    &[disabled] {
      background: ${props => props.theme.colors.greyLight};
      border-color: ${props => props.theme.colors.greyLight};
      color: white;
    }
  `
}

function secondary() {
  return css`
    ${primary()}

    background: none;
    color: ${palette('Base')};
  `
}

function tertiary() {
  return css`
    ${props => textstyle(palette('Base')(props))}
    border: none;
    cursor: pointer;
    outline: none;
    background: none;
    padding: 0;

    &:hover {
      ${props => textstyle(palette('Darker')(props))}
    }
  `
}

function textstyleOnly() {
  return css`
    ${props => textstyle(palette('Base')(props))}
  `
}

function getMixin(mode) {
  switch(mode) {
    case 'primary': return primary
    case 'secondary': return secondary
    case 'textstyle-only': return textstyleOnly
    default: return tertiary
  }
}

// Raw component class that can be used as a base to be restyled in styled-components

export function buttonComponent(element, mode='tertiary') {
  const mixin = getMixin(mode)
  return styled(element)`${mixin()}`
}

// Polymorphic Button class
//  -- the styling gets created at render so it cannot be overridden by styled components
//  -- use `buttonComponent` in that case.

const Button = props => {
  const { element, mode, ...remianingProps } = props

  const Comp = buttonComponent(element, mode)

  return <Comp {...remianingProps} />
}

// HTML BUTTON

export const BasicButton = props => <Button element="button" {...props} />

// ANCHOR

export const AnchorButton = props => <Button element="a" {...props} />

// REACT ROUTER LINK

export const LinkButton = props => <Button element={Link} {...props} />

// DIV BUTTON

export const DivButton = props => <Button element="div" {...props} />